// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PTFQfmr4Bw12SC0nC4cP{padding-bottom:16px;overflow-y:auto}._NgHRrXmgiqZrWHAoCps{width:100%;height:23px;color:var(--content-primary-disabled);justify-content:center;align-items:center;margin-bottom:16px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `PTFQfmr4Bw12SC0nC4cP`,
	"date": `_NgHRrXmgiqZrWHAoCps`
};
export default ___CSS_LOADER_EXPORT___;
